var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "504.000000pt",
    height: "336.000000pt",
    viewBox: "0 0 504.000000 336.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,336.000000) scale(0.100000,-0.100000)",
    fill: "inherit",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1535 3131 c-247 -103 -661 -274 -920 -381 -258 -107 -483 -204 -499 -215 -64 -43 -96 -123 -77 -192 20 -72 47 -102 124 -138 167 -78 1825 -758 1859 -762 51 -7 135 34 167 83 35 51 40 136 12 191 -24 49 -54 71 -139 107 -104 44 -1295 537 -1322 548 -29 11 -119 -28 789 348 411 170 614 259 634 278 58 54 74 149 38 220 -23 46 -46 67 -94 87 -74 31 -96 24 -572 -174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2892 3299 c-79 -40 -120 -139 -92 -224 28 -86 14 -78 779 -395 391 -162 707 -297 703 -301 -4 -4 -149 -65 -322 -137 -878 -362 -1077 -446 -1102 -463 -35 -25 -68 -96 -68 -145 1 -118 116 -213 225 -186 22 5 454 181 960 391 614 255 929 391 947 408 79 76 71 219 -16 284 -12 9 -441 191 -954 403 -725 300 -942 386 -975 386 -23 0 -61 -10 -85 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1183 l0 -486 25 -43 c14 -23 39 -51 57 -62 18 -11 347 -144 731 -296 546 -216 707 -276 742 -276 36 0 186 57 716 270 369 149 687 278 706 286 19 10 44 34 58 59 l25 42 -2 495 -3 495 -180 -76 -180 -77 -3 -321 c-2 -243 -5 -322 -15 -326 -6 -3 -270 -107 -584 -231 l-573 -226 -572 226 c-315 124 -579 228 -585 231 -10 4 -13 80 -13 332 l0 327 -42 16 c-24 9 -103 41 -175 71 l-133 55 0 -485z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5927a368.svg";
export { ForwardRef as ReactComponent };